import Select from "react-select";
import { Form } from "react-bootstrap";

function SelectLocalidade({ isLoading, setLoading, loadData, localidades }) {


    return (
        <Form.Group>
            <Form.Label style={{ fontWeight: 'bold' }}>Selecione o município:</Form.Label>
            <Select
                autoFocus={true}
                className="basic-single"
                classNamePrefix="select"
                isLoading={isLoading}
                isDisabled={isLoading}
                isClearable={true}
                isSearchable={true}
                placeholder="Digite a localidade..."
                onChange={(obj) => { setLoading(false); loadData(obj) }}
                name="color"
                id="teste"
                options={localidades}
            />
        </Form.Group>
    );
}

export default SelectLocalidade;